import React, { Component } from "react";
import {
	Card,
	CardHeader,
	Button,
	CardBody,
	Row,
	Col,
	Table,
	Badge,
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import TableScrollbar from "react-table-scrollbar";

import Moment from "moment";

import DefaultImg from "../../assets/images/product/Default_img.jpg";
import {
	getAuditMRRowData,
	AuditPopRight,
} from "../../store/Audit_Report/actions";

class IndentRequestCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			maximize: true,
		};
	}
	maximizetogle() {
		this.setState((prevState) => ({
			maximize: !prevState.maximize,
		}));
	}
	callNextCard(id) {
		if (this.props.AuditData.length - 1 === this.props.index) {
			this.props.getAuditMRRowData({
				ScreenID: id,
			});
			this.setState((prevState) => ({
				maximize: !prevState.maximize,
			}));
		}
	}

	render() {
		var obj = {};
		obj = this.props.obj;
		return (
			<div className={this.state.maximize ? "maximize" : "minimize"}>
				<>
					<Row className="plaseholder">
						<Col>
							<Card className="mb-0 mt-0">
								<CardHeader className="bg-transparent border-bottom ">
									<h5 className="card-title-18 pt-2 d-inline-block">
										Purchase Indent Request (#
										{obj.data.code})
									</h5>
								</CardHeader>
								<CardBody className="pt-1">
									<Row className="p-1">
										<Col
											md={12}
											className="p-1 m-0 border-bottom">
											<div className="p-1 m-0">
												<CardBody className="pt-1 pb-1">
													<Row className="p-0">
														<Col
															md={8}
															className="p-1 m-0">
															<div className="Indent-Request-panel-content">
																<div className="list-column">
																	<Row>
																		<Col
																			md={
																				6
																			}>
																			<ul className="list-style-two p-0">
																				<li className="clearfix">
																					<span className="ttl">
																						Request
																						By:
																					</span>
																					<span className="dtl">
																						{
																							obj
																								.data
																								.createdby
																								?.fullname
																						}
																					</span>
																				</li>
																				<li className="clearfix">
																					<span className="ttl">
																						Location:{" "}
																					</span>
																					<span className="dtl">
																						{
																							obj
																								.data
																								.location
																								?.name
																						}
																					</span>
																				</li>

																				<li className="clearfix">
																					<span className="ttl">
																						User
																						Department:
																					</span>
																					<span className="dtl">
																						{
																							this
																								.props
																								.PIreqRowData
																								?.userdepartment
																								?.name
																						}
																					</span>
																				</li>
																				<li className="clearfix">
																					<span className="ttl">
																						description:
																					</span>
																					<span className="dtl">
																						{
																							this
																								.props
																								.PIreqRowData
																								?.description
																						}
																					</span>
																				</li>
																			</ul>
																		</Col>
																		<Col
																			md={
																				6
																			}>
																			<ul className="list-style-two p-0">
																				<li className="clearfix">
																					<span className="ttl">
																						Department:
																					</span>
																					<span className="dtl">
																						{
																							this
																								.props
																								.PIreqRowData
																								?.department
																								?.name
																						}
																					</span>
																				</li>
																				<li className="clearfix">
																					<span className="ttl">
																						Submited
																						Date:
																					</span>
																					<span className="dtl">
																						{" "}
																						{Moment(
																							obj
																								.data
																								.createdon
																						).format(
																							"DD-MM-YYYY"
																						)}
																					</span>
																				</li>
																				<li className="clearfix">
																					<span className="ttl">
																						Status:
																					</span>

																					<span className="dtl font-size-18">
																						<Badge
																							color={
																								this
																									.props
																									.PIreqRowData
																									?.pistatus ===
																									1 ||
																								this
																									.props
																									.PIreqRowData
																									?.pistatus ===
																									2
																									? "primary "
																									: this
																											.props
																											.PIreqRowData
																											?.pistatus ===
																									  3
																									? "success "
																									: "danger "
																							}>
																							{
																								this
																									.props
																									.PIreqRowData
																									?.pistatus_name
																							}
																						</Badge>
																					</span>
																				</li>
																			</ul>
																		</Col>
																	</Row>
																</div>
															</div>
														</Col>
														<Col
															md={4}
															className="p-0 mt-0"></Col>
													</Row>
												</CardBody>
											</div>
										</Col>
										<Col md={12} className="p-1">
											<div className="p-1">
												<Col md={12} className="m-0">
													<div
														style={{
															textAlign: "left",
															background: "#FFF",
															padding: "5px;",
														}}>
														<h3 className="card-title-15 pt-2">
															Purchase Indent
															Items List
														</h3>
													</div>
													<div className="table-responsive m-0">
														<TableScrollbar height="450px">
															<Table className="mb-0 p-0 table-centered  ">
																<thead className="bg-light text-center">
																	<tr>
																		<th className="nowrap">
																			Item
																			Images
																		</th>
																		<th
																			style={{
																				minWidth:
																					"220px",
																			}}>
																			Item
																			Name
																		</th>
																		<th className="nowrap">
																			Required
																			Qty
																		</th>
																		<th className="nowrap">
																			Indent
																			Quantity
																		</th>
																		<th className="nowrap">
																			Department
																		</th>
																		<th className="nowrap">
																			Action
																		</th>
																	</tr>
																</thead>
																<tbody className=" text-center">
																	{obj.data.piitems?.map(
																		(
																			item,
																			key
																		) => (
																			<tr
																				key={
																					key
																				}>
																				<td className="nowrap text-center">
																					<div className="product-detail text-center">
																						<img
																							src={
																								item
																									?.product
																									?.image ==
																								null
																									? DefaultImg
																									: item
																											?.product
																											?.image
																							}
																							alt="product-img"
																							title="product-img"
																							className="product-img  img-fluid mx-auto tab-img rounded"
																							style={{
																								height: "100px",
																								width: "150px",
																							}}
																						/>
																					</div>
																				</td>
																				<td className="text-left">
																					<h5 className="font-size-14 ">
																						{item
																							.piimris
																							.length ===
																						0 ? (
																							<>
																								{
																									item
																										?.product
																										.name
																								}{" "}
																								<Badge color="primary">
																									new
																								</Badge>
																							</>
																						) : (
																							<>
																								<Link
																									to="#"
																									onClick={() => {
																										this.callNextCard(
																											item
																												?.piimris[
																												item
																													?.piimris
																													.length -
																													1
																											]
																												.mritem
																												?.materialrequest_id
																										);
																									}}
																									className="text-primary mr-1">
																									<u>
																										{
																											item
																												?.product
																												.name
																										}
																									</u>
																								</Link>
																								{item
																									.piimris
																									.length ===
																									0 && (
																									<Badge color="primary">
																										new
																									</Badge>
																								)}
																							</>
																						)}
																					</h5>
																					<p className="mb-0">
																						Make
																						:{" "}
																						<span className="font-weight-medium">
																							{
																								item.make
																							}
																						</span>
																					</p>
																					<p className="mb-0">
																						Description
																						:{" "}
																						<span className="font-weight-medium">
																							{
																								item.description
																							}
																						</span>
																					</p>
																				</td>
																				<td className="nowrap text-center">
																					{item
																						.pii_approvals
																						.length ===
																					0
																						? item.qty +
																						  " " +
																						  item
																								.unit
																								?.name
																						: item
																								.pii_approvals[0]
																								.f_qty +
																						  " " +
																						  item
																								.pii_approvals[0]
																								.f_unit
																								.name}
																				</td>
																				<td className="nowrap text-center">
																					{
																						item.qty
																					}{" "}
																					{
																						item
																							?.unit
																							.name
																					}
																				</td>
																				<td className="nowrap text-center">
																					{
																						item
																							.product
																							.department
																							?.name
																					}
																				</td>

																				<td className="nowrap text-center">
																					<Button
																						type="button"
																						color={
																							item.pistatus ===
																								1 ||
																							item.pistatus ===
																								2
																								? "primary"
																								: item.pistatus ===
																										3 ||
																								  item.pistatus ===
																										7 ||
																								  item.pistatus ===
																										8
																								? "success"
																								: "danger"
																						}
																						className="waves-effect waves-light mr-2"
																						disabled={
																							true
																						}>
																						{item.pistatus ===
																							1 ||
																						item.pistatus ===
																							2
																							? "Pending"
																							: item.pistatus ===
																									3 ||
																							  item.pistatus ===
																									7 ||
																							  item.pistatus ===
																									8
																							? "Approved"
																							: "Rejected"}
																					</Button>
																				</td>
																			</tr>
																		)
																	)}
																</tbody>
															</Table>
														</TableScrollbar>
													</div>
												</Col>
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
					</Row>
					<Link
						to="#"
						className="strip"
						onClick={() => {
							this.maximizetogle();
							this.props.AuditPopRight(this.props.index);
						}}>
						<div className="MaximizeCard-item mb-2 ">
							<div className="MaximizeCard-title-box d-inline-block">
								<span className="mt-4">
									Purchase Indent Request ({obj.data.code})
								</span>
							</div>
						</div>
					</Link>
				</>
			</div>
		);
	}
}

const mapStatetoProps = (state) => {
	const { AuditData } = state.AuditReport;
	return { AuditData };
};

export default connect(mapStatetoProps, {
	getAuditMRRowData,
	AuditPopRight,
})(IndentRequestCard);
